import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ProjectTypeService } from '../shared/project-type.service';
import { PagedSearch, TranslationService, NotificationService } from 'src/app/shared';
import { ProjectService } from '../shared/project.service';
import { ProjectDto } from '../shared/dto/project.dto';
import { ProjectTypeDto } from '../shared/dto/project-type.dto';

@Component({
  selector: 'wl-task-generate-dialog',
  templateUrl: './task-generate-dialog.component.html',
  styleUrls: ['./task-generate-dialog.component.less'],
    standalone: false
})
export class TaskGenerateDialogComponent implements OnInit {
  show = false;
  isSaving = false;
  projectTypeOptions: SelectItem[];
  selectedProjectId: number;
  startDate: Date;
  profileId = 0;
  allProjectTypes: Array<ProjectTypeDto>;
  constructor(
    private _projectService: ProjectService,
    private _projectTypeService: ProjectTypeService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this._projectTypeService.search({ PageNumber: 0, PageSize: 0 } as PagedSearch).then((data) => {
      this.allProjectTypes = data.Result;
      this.projectTypeOptions = data.Result.map((x) => {
        return { label: x.ProjectType, value: x.ProjectTypeID } as SelectItem;
      });
    });
  }

  generate() {
    const projectType = this.allProjectTypes.find((x) => x.ProjectTypeID === this.selectedProjectId);
    const project = {
      ProjectTypeId: this.selectedProjectId,
      ProjectName: projectType.ProjectType,
      EstimatedStartDate: this.startDate,
      ProfileId: this.profileId,
      CreateTasks: true,
    } as ProjectDto;
    this._projectService
      .createProject(project)
      .then((x) => {
        this._notificationService.translateSuccess('common.success');
        this.show = false;
      })
      .finally(() => (this.isSaving = false));
  }

  open(profileId: number) {
    this.startDate = null;
    this.profileId = profileId;
    this.show = true;
  }
}
